import React, { useEffect, useState } from "react";

import style from "./CategoriesManagement.module.css";
import axios from "axios";
import { baseUrl } from "../../data/baseURL";
import { format } from "date-fns-jalali";
import { useNavigate } from "react-router-dom";

export default function CategoriesManagement(props){
    const navigate = useNavigate();

    let [allCallCounts, setAllCallCounts] = useState(0);

    let [showUi, setShowUi] = useState(false);
    let [editingId, setEditingId] = useState(0);
    let [editingTitle, setEditingTitle] = useState("");

    let [data, setData] = useState([]);

    useEffect(() => {
        axios.get(baseUrl + "/Calls/CallCount", {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token")
            }
        }).then((res) => {
            setAllCallCounts(res.data?.data)
        });
    }, [])

    useEffect(() => {
        axios.get(baseUrl + "/Calls/Category", {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token")
            }
        }).then((res) => {
            setData(res.data?.data)
        });
    }, []);

    function deleteHandle(id){
        axios.delete(baseUrl + "/Calls/Category", {
            params: {
                id: id
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token")
            }
        }).then((res) => {
            alert(res.data.message);
            window.location.reload();
        });
    }

    function openHandle(){
        setShowUi(true);
    }

    function editHandle(id){
        setShowUi(true);
        setEditingId(id);
        setEditingTitle(data.find(d => d.id == id)?.name);
    }

    function closeHandle(){
        setEditingId(0); 
        setShowUi(false);
        setEditingTitle("");
    }

    function submitHandle(){
        if (editingId != 0){
            if (editingTitle != ""){
                axios.put(baseUrl + "/Calls/Category", {
                    id: editingId,
                    name: editingTitle
                }, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token")
                    }
                }).then((res) => {
                    alert(res.data.message);
                    window.location.reload();
                });
            }
        }else{
            if (editingTitle != ""){
                axios.post(baseUrl + "/Calls/Category", {
                    name: editingTitle
                }, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token")
                    }
                }).then((res) => {
                    alert(res.data.message);
                    window.location.reload();
                });
            }
        }
    }

    return <>
        <div className={`${style.container}`}>
            <div className={`${style.popup} ${showUi? "" : style.popup_hidden}`}>
                <div className={`${style.popup_container}`}>
                    <div className={`${style.popup_header}`} onClick={() => {closeHandle()}}>
                        <div className={`${style.popup_header_title}`}>
                            دسته بندی
                        </div>
                        <div className={`${style.popup_header_icon}`}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" style={{width: "20px", height: "20px"}}><path d="M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"/></svg>
                        </div>
                    </div>
                    <div className={`${style.popup_content}`}>
                        <div className={`${style.popup_input}`}>
                            <input placeholder="عنوان دسته بندی" value={editingTitle} onChange={(ev) => setEditingTitle(ev.target.value)} className={`${style.popup_input_input}`}></input>
                        </div>
                        <div className={`${style.popup_submit}`}>
                            <div className={`${style.popup_submit_text}`} onClick={submitHandle}>
                                ثبت
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${style.header}`}>
                <div className={`${style.header_title}`}>
                    مدیریت دسته بندی
                </div>
            </div>
            <div className={`${style.content}`}>
                <div className={`${style.table}`}>
                    <div className={`${style.table_header}`}>
                        <div className={`${style.table_header_item}`} style={{width: "33%"}}>
                            ردیف
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "33%"}}>
                            نام
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "33%"}}>
                            اکشن
                        </div>
                    </div>
                    <div className={`${style.table_body}`}>
                        {
                            data.map((d, index) => {
                                return <div className={`${style.table_body_i}`}>
                                    <div className={`${style.table_body_item}`} style={{width: "33%"}}>
                                        {index + 1}
                                    </div>
                                    <div className={`${style.table_body_item}`} style={{width: "33%"}}>
                                        {d.name}
                                    </div>
                                    <div className={`${style.table_body_item}`} style={{width: "33%"}}>
                                        <div className={`${style.table_actions}`}>
                                            <div className={`${style.table_actions_edit}`} title="ویرایش" onClick={() => editHandle(d.id)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c12.4-3.6 23.7-9.9 33.4-18.4c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4zm46 13.5c1.7-5.6 4.5-10.8 8.4-15.2c.6-.6 1.1-1.2 1.7-1.8L321 129 383 191 154.6 419.5c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4z"/></svg>
                                            </div>
                                            <div className={`${style.table_actions_delete}`} title="حذف" onClick={() => deleteHandle(d.id)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z"/></svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })
                        }
                        { data.length == 0? <div className={`${style.table_body_item}`} style={{gridColumnStart: 1, gridColumnEnd: 4, width: "100%"}}>
                            بدون داده
                        </div> : <></>}
                    </div>
                </div>
                <div className={`${style.page}`}>
                    <div className={`${style.page_item} ${style.page_item_center}`} onClick={() => openHandle()}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className={`${style.page_icons}`}><path d="M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z"/></svg>
                    </div>
                </div>
            </div>
        </div>
    
    </>
}